import { ISupplier } from '@bridebook/models/source/models/Suppliers.types';
import { supplierDetailsList } from '../supplier-details-list';

export const fullDescriptionVisibility = (supplier?: ISupplier): boolean => {
  const descriptionLong = supplier?.description?.long;
  const managerMessage = supplier?.company?.manager?.welcomeMessage;
  const detailsList = supplierDetailsList.map(
    (item) => supplier?.company?.[item as keyof ISupplier['company']],
  );

  const checkDetailsList = detailsList.every((item) => item === 0 || item === '' || item === false);

  return descriptionLong !== '' || managerMessage !== '' || !checkDetailsList;
};
